import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const BloombergButton = ({ children, onClick, className = '' }) => {
  return (
    <button 
      onClick={onClick}
      className={`px-6 py-2 text-sm font-bold uppercase tracking-widest transition-all duration-200 border flex items-center gap-2 bg-black text-white border-black hover:bg-zinc-800 ${className}`}
    >
      {children}
    </button>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'text-black' : 'text-zinc-500 hover:text-black';
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'Tentang Kami' },
    { path: '/partnership', label: 'Kemitraan' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/articles', label: 'Artikel' },
    { path: '/karir', label: 'Karir' },
    { path: '/contact', label: 'Kontak' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white border-b border-zinc-200 py-3' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center gap-8">
          <Link to="/" className="text-2xl font-black tracking-tighter" onClick={closeMenu}>
            iMoonusel<span className="text-blue-600">.</span>
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden lg:flex gap-6 text-sm font-bold uppercase tracking-widest text-zinc-800">
            {navLinks.slice(0, 6).map((link) => (
              <Link 
                key={link.path} 
                to={link.path} 
                className={`transition-colors ${isActive(link.path)}`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          <div className="hidden sm:block text-xs text-right mr-4 leading-tight font-medium text-zinc-600">
            BANDUNG EST. 2012<br/>
            MARKET STATUS: <span className="text-green-600 text-sm font-bold underline">OPEN</span>
          </div>
          
          <button className="lg:hidden" onClick={toggleMenu} aria-label="Toggle menu">
            {isOpen ? <X /> : <Menu />}
          </button>

          <Link to="/contact" className="hidden lg:block">
            <BloombergButton>
              Konsultasi Produksi
            </BloombergButton>
          </Link>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-white border-b border-zinc-200 p-6 flex flex-col gap-4 lg:hidden shadow-xl">
          {navLinks.map((link) => (
            <Link 
              key={link.path} 
              to={link.path} 
              onClick={closeMenu}
              className={`text-xl font-bold border-b border-zinc-100 pb-2 ${location.pathname === link.path ? 'text-blue-600' : 'text-black'}`}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" onClick={closeMenu} className="mt-2">
            <BloombergButton className="w-full justify-center">
              Konsultasi Produksi
            </BloombergButton>
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;